import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  centered: {
    width: '100%',
    marginTop: '2.5rem',
    paddingBottom: '4rem',
    textAlign: 'center',
  },
  container: {
    width: '100%',
  },
  header: {
    display: 'flex',
    width: 'calc(100% - 12px)',
    padding: '16px 16px 8px',
  },
  organizeStoriesText: {
    fontWeight: foundations.typography.fontWeight.normal,
    width: '30%',
  },
  organizeStoriesDefaultText: {
    fontWeight: foundations.typography.fontWeight.light,
    width: '30%',
  },
  listItem: {
    display: 'flex',
    width: '100%',
    padding: '0 8px',
  },
});
